import { render } from "./StoreProducts.vue?vue&type=template&id=5628ff34&scoped=true"
import script from "./StoreProducts.vue?vue&type=script&lang=js"
export * from "./StoreProducts.vue?vue&type=script&lang=js"

import "./StoreProducts.vue?vue&type=style&index=0&id=5628ff34&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5628ff34"]])

export default __exports__